import { Box, Button } from "@mui/material";
import { UUID } from "crypto";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { scrollQuestionIntoView } from "../../../utils/scrollQuestionIntoView";
import useMarketResearchStore from "../useMarketResearchStore";

import ChangeStudyButton from "../ChangeStudyButton";
import { BodyPanel, MainPanel, RightPanel } from "../Layout/Panels";
import StudyHeader from "../Layout/StudyHeader";
import ChatAnswerNode from "../StudyChat/ChatAnswerNode";
import InterviewComponent from "../ViewStudy/InterviewComponent";
import useStudyMetadataStore from "../useStudyMetadataStore";

export const isValidQuestion = (question: string) => {
  const text = String(question);
  const words = text.split(" ");
  return text.length > 8 && words.length > 2 && words.some((_word) => _word.length > 2);
};

interface UriParams {
  studyId: UUID;
}

export default function GenerateSummary() {
  const { studyId } = useParams() as unknown as UriParams;
  const navigate = useNavigate();
  const location = useLocation();

  const { respondent_id_selection } = location.state || {};

  const { messages, getStudy, isLoadingChat, socketStatusMessage, resetSocket } = useMarketResearchStore();

  // Scroll to the top of the summary when it starts generating
  useEffect(() => {
    const target = messages.at(0);
    if (target) {
      const anchorId = `${target.user_chat_session}-0`;
      scrollQuestionIntoView(anchorId);
    }
  }, [messages.length]);

  // Try to get study details by its "study_key"
  const pmrStudy = getStudy(studyId);

  const { study } = useStudyMetadataStore(studyId as UUID);

  return (
    <MainPanel>
      <BodyPanel>
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", paddingBottom: "32px", padding: "2px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
            flexDirection={"row"}
          >
            <StudyHeader study={study} />
            <ChangeStudyButton />
          </Box>

          {messages.map((interaction, i) => {
            const anchorId = `${String(interaction.user_chat_session)}-${i}`;
            const isLastItem = messages.at(-1) === interaction;
            return (
              <ChatAnswerNode
                key={i}
                anchorId={anchorId}
                interaction={interaction}
                isLoading={isLastItem && isLoadingChat}
                loadingStatus={socketStatusMessage}
                fromSummary={true}
              />
            );
          })}
        </Box>
      </BodyPanel>

      <RightPanel>
        {pmrStudy && (
          <InterviewComponent
            study={pmrStudy}
            respondentIds={respondent_id_selection}
            sx={{
              flex: 1,
              overflowY: "auto",
            }}
          />
        )}

        <Button
          variant="outlined"
          sx={{
            color: "#003087",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            marginTop: "auto",
          }}
          onClick={() => {
            if (isLoadingChat) {
              resetSocket();
            }
            navigate(-1);
          }}
        >
          BACK TO INTERVIEWS
        </Button>
      </RightPanel>
    </MainPanel>
  );
}
